export default __webpack_public_path__ + "static/media/appointments.f67ac816.svg";